import '../../styles/whatYouGet.css';

type Card = {
  text: string;
};

type WhatYouGetProps = {
  sectionHeading: string;
  content: Card[];
};


const WhatYouGet: React.FC<WhatYouGetProps> = ({sectionHeading , content}) => {
    return (
    <section className="what-you-get-section">
        <div className='what-you-get-content'>
            <h2 className="sections-title">{sectionHeading}</h2>
            <div className="what-you-get-container">
                {content.map((feature, index) => (
                <div key={index} className="what-you-get-card">
                    <div className='what-you-get-card-content'>
                    <p className="what-you-get-text">{feature.text}</p>
                    </div>
                </div>
                ))}
            </div>
        </div>
    </section>
  );
};

export default WhatYouGet; 